export const capitalizeTitle = (str: string) => (str ? str.charAt(0).toUpperCase() + str.substr(1).toLowerCase() : '');
